//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import qrCode from '~/components/j/qrCode.vue' // 二维码
import TencentPlayer from '~/components/liveroom/TencentPlayer.vue' // 回放
import liveBroad from '~/components/liveroom/liveBroad.vue' // 直播
import liveList from '~/components/liveroom/liveList.vue' // list
export default {
  components: {
    'qr-code': qrCode,
    'tencent-player': TencentPlayer,
    'live-broad': liveBroad,
    'live-list': liveList // 列表
  },
  props: {
    liveDetail: { // 直播详情数据
      type: Object,
      default: () => {}
    },
    liveConfig: { // 直播切流数据
      type: Object,
      default: () => {}
    },
    translateLanguageList: { // 字幕语言
      type: Object,
      default: () => {}
    },
    reportList: { // 举报数据
      type: Object,
      default: () => {}
    },
    cutflowState: { // 切流状态
      type: Boolean,
      default: false
    },
    endLive: { // 结束直播
      type: Boolean,
      default: false
    },
    num: { // 结束直播人数
      type: [Number, String],
      default: 0
    },
    location: { // 摄像头位置
      type: [Number, String],
      default: 0
    },
    livelike: { // 结束直播猜你喜欢
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      qrUrl: '',
      liveDeta: this.liveDetail, // 直播详情数据
      weixinQr: false, // 二维码弹框
      reportpop: false, // 举报弹框
      reportState: 1001, // 举报选择状态
      liveCode: this.$route.params.id && this.$route.params.id.split('.')[0], // 直播code
      notice_show: false, // 预约成功弹框
      time_arr: ['00', '00', '00', '00'], // 倒计时时间
      Tips: '', // 举报/预约提示
      options: {
        fileID: this.liveDetail.livestatus == 3 ? (this.liveDetail.videos[0] && this.liveDetail.videos[0].fileId) : '', // 请传入需要播放的视频 filID（必须）
        appID: this.liveDetail.livestatus == 3 ? (this.liveDetail.videos[0] && this.liveDetail.videos[0].appId) : '', // 请传入点播账号的 appID（必须）
        autoplay: true,
        url: this.liveDetail.livestatus == 3 ? (this.liveDetail.videos[0] && this.liveDetail.videos[0].videoUrl) : ''
      },
      subTxt: this.translateLanguageList.items[0].translatelanguageshow,
      sublang: this.translateLanguageList.items[0].translatelanguage,
      subLang: false, // 字幕语言弹框
      langState: false, // m端字幕语言弹框
      livestatusstate: false, // 界面是否为直播跳转
      mfullscreen: false,
      isanchor: false // 主播是否开始直播
    }
  },
  computed: {
    ...mapState({
      contentcookie: 'contentcookie'
    }),
    isZh () {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    '$store.state.contentcookie' (newVal) {
      if (newVal) {
        this.getDetails()
      }
    }
  },
  created () {
    if (this.$cookies.get(`anchor${this.liveDetail.livecode}`)) {
      this.$store.commit('setanchor', this.$cookies.get(`anchor${this.liveDetail.livecode}`))
    }
  },
  mounted () {
    if (this.liveDetail.livestatus == 2) {
      this.set_time()
    }
    this.$nextTick(() => {
      this.qrUrl = window.location.href
      if (this.liveDetail.livestatus == 3) this.$refs.TencentPlayer.onoptions()
      this.$store.commit('set_lang_speak_lang', this.translateLanguageList.items[0].translatelanguage)
    })
  },
  methods: {
    fullscreen (i) {
      console.log('i: ', i)
      this.$emit('fullscreen', i)
      this.mfullscreen = i
    },
    switchsublang (i) { // pc字幕语言
      this.subTxt = i.translatelanguageshow
      this.sublang = i.translatelanguage
      this.$store.commit('set_lang_speak_lang', i.translatelanguage)
    },
    language (i) { // m端字幕语言
      this.subTxt = i.translatelanguageshow
      this.sublang = i.translatelanguage
      this.langState = false
      this.$store.commit('set_lang_speak_lang', i.translatelanguage)
    },
    closeLink () { // 点击关闭按钮
      window.open(`/${this.$store.state.LanguageCode}`)
    },
    report () { // 点击举报
      if (this.contentcookie) return (this.reportpop = true)
      this.$store.commit('loginClose', true)
    },
    async livemakean () { // 预约直播
      console.log('this.liveDetail.issub: ', this.liveDetail.issub)
      if (!this.contentcookie) return this.$store.commit('loginClose', true)
      if (this.liveDetail.issub) return
      // console.log('this.liveDetail.issub: ', this.liveDetail.issub)
      // console.log('预约')
      const { succeed = false, message } = await this.$api.liveroom.livemakean({
        livecode: this.liveCode,
        userid: this.$store.state.user.userId,
        playid: '',
        issub: true
      })
      if (succeed) return this.$message.error(message) // 数据错误
      this.Tips = '预约成功'
      this.liveDeta.issub = true // 举报成功则数据改变
      this.notice_show = true
      setTimeout(() => {
        this.notice_show = false
      }, 2000)
      this.reportpop = false // 举报弹框关闭
    },
    async reportsubmission () { // 举报提交
      const { succeed = false, message } = await this.$api.liveroom.livereport({
        livecode: this.liveCode,
        userid: this.$store.state.user.userId,
        reporttype: this.reportState
      })
      if (succeed) return this.$message.error(message) // 数据错误
      this.Tips = '提交成功'
      this.notice_show = true
      setTimeout(() => {
        this.notice_show = false
      }, 2000)
      this.reportpop = false // 举报弹框关闭
    },
    async getDetails () { // 获取直播详情
      const res = await this.$api.liveroom.liveDetailscl({
        liveCode: this.liveCode, // 直播code
        userId: this.$store.state.contentcookie ? this.$store.state.user.userId : '' // 用户id
      })
      this.liveDeta = res.liveDetail
    },
    set_time () { // 计算预约倒计时
      this.setTime = setInterval(() => {
        const starttimestamp = this.liveDetail.wiki_timestamp_start
        const endDate = new Date(starttimestamp)
        const nowDate = new Date()
        let totalSeconds = parseInt((endDate - nowDate) / 1000)
        // let now_time = new Date().getTime();
        this.TimeDown(totalSeconds)
        totalSeconds--
        if (totalSeconds < '0') {
          clearInterval(this.setTime)
          this.setInter = setInterval(() => {
            // this.$emit('countdown')
            this.getisdetails()
            if (this.livestatusstate) {
              clearInterval(this.setInter)
            }
          }, 3000)
        }
      }, 1000)
    },
    async getisdetails () { // 倒计时完成检测是否开播
      const liveCode = this.$route.params.id && this.$route.params.id.split('.')[0] // 直播id
      if (this.livestatusstate) return false
      const res = await this.$api.liveroom.liveisDetails({
        liveCode // 直播code
      })
      // this.liveDetail = res.liveDetail
      if (res.livestatus == 1) {
        this.livestatusstate = true
        location.reload()
      }
    },
    TimeDown (totalSeconds) { // 倒计时封装
      if (totalSeconds < 0) {
        this.time_arr = ['00', '00', '00', '00']
        return
      }
      // 结束时间
      // 当前时间
      // 相差的总秒数
      // 天数
      let days = Math.floor(totalSeconds / (60 * 60 * 24))
      // 取模（余数）
      let modulo = totalSeconds % (60 * 60 * 24)
      // 小时数
      let hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      // 分钟
      let minutes = Math.floor(modulo / 60)
      // 秒
      let seconds = modulo % 60
      // console.log("还剩:" + days + "天" + hours + "小时" + minutes + "分钟" + seconds + "秒", 888);
      days = (days <= 9 ? ('0' + days) : days)
      hours = (hours <= 9 ? ('0' + hours) : hours)
      minutes = (minutes <= 9 ? ('0' + minutes) : minutes)
      seconds = (seconds <= 9 ? ('0' + seconds) : seconds)
      this.time_arr = [days, hours, minutes, seconds]
    }
  }
}
